



































































import { Component, Prop, Watch, Vue } from 'vue-property-decorator'
import TextInput from '../BaseTextInput.vue'
import Address from '../BaseAddress.vue'
import Banner from '../BaseBanner.vue'
import Button from '../BaseButton.vue'
import Card from '../BaseCard.vue'
import CardContent from '../BaseCardContent.vue'
import Chip from '../BaseChip.vue'
import Instructions from '../BaseInstructions.vue'
import LoginForm from '../LoginForm.vue'
import { State, Getter, Action, Mutation, namespace } from 'vuex-class'
import countries from '@/utils/countries'

const cart = namespace('cart')
const user = namespace('user')

@Component({
  components: { TextInput, Address, Banner, Button, Card, CardContent, Chip, Instructions, LoginForm },
})
export default class ShippingInfo extends Vue {
  @cart.State((state: any) => state.shipping.address) address: Address
  @cart.State shippingInvalidCountries: string[]
  @cart.State email: string
  @user.State isReturningCustomer: boolean
  @cart.State isVip: boolean
  @user.State loginEmailRequested: boolean
  @user.State username: string
  @user.State((state: any) => state.shipping.address) userShipping: Address
  @cart.State loginFormActive: boolean
  @user.State loginErrorMessage: string
  @cart.State useStoredShippingInfo: boolean
  @cart.Getter fullName: string

  @user.Getter loggedIn: string

  @cart.Mutation setEmail: any
  @cart.Mutation setAddress: any
  @cart.Mutation replaceShippingAddress: any
  @cart.Mutation toggleLoginForm: any
  @cart.Mutation clearLoginForm: any
  @cart.Mutation editStoredShippingAddress: any

  @user.Action logout: any
  @cart.Action updateCart: () => Promise<void>
  @cart.Action identifyTrack: ({ name, email }: {name?: string, email?: string}) => Promise<void>
  @cart.Action sendCheckoutStartEvent: () => Promise<void>

  welcomeBackCardDismissed: boolean = false

  update: Function

  debounce (func: Function, wait = 400): any {
    let timeout: number
    return (...args: any[]) => {
      clearTimeout(timeout)
      timeout = setTimeout(() => func.apply(this, args), wait)
    }
  }

  created () {
    this.update = this.debounce(this.updateCart)
  }

  updateAddress ($event: FormInputEvent) {
    this.setAddress({
      location: 'shipping',
      field: $event.name,
      value: $event.value,
    })

    if ($event.name === 'country' || $event.name === 'state') {
      this.update()
    }
  }

  handleLogoutClicked (e: MouseEvent) {
    e.preventDefault()
    this.logout()
  }

  handleBlurEmail (name: string, email: string) {
    this.update()
    this.identifyTrack({ email })
  }

  handleBlur (name: string, value: string) {
    if (name === 'givenName' || name === 'familyName') {
      this.identifyTrack({ name: this.fullName })
      this.sendCheckoutStartEvent()
    }
  }

  get currentCountry () {
    if (this.useStoredShippingInfo && this.username && this.userShipping) {
      return this.userShipping.country
    }

    return this.address.country
  }

  getCountryName (code: string) {
    const name = countries.find(tuple => tuple[1] === code)
    return Array.isArray(name) ? name[0] : code
  }
}
